// Packages:
import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Position } from 'react-flow-renderer';
import hasNodeMoved from '../../../../lib/hasNodeMoved';

// Redux:
import { setSelectedNode } from '../../../../redux/actions/studioActions';

// Styles:
import {
  TicketNodeWrapper,
  TicketNodeLabel,
  Body,
  Description,
  Field,
  StyledHandle
} from './styles';

// Functions:
const TicketNode = ({ data }) => {
  // Constants:
  const dispatch = useDispatch();
  const { id, ticketChannel, subject, label } = data;

  // Ref:
  const wrapperRef = useRef(null);

  // State:
  const studio = useSelector((state) => state.studio);
  const [clickOrigin, setClickOrigin] = useState({ x: 0, y: 0 });

  // Functions:
  const handleMouseDown = useCallback(
    (e) => {
      if (e.button === 2) e.stopPropagation();
      if (e.button === 0) {
        setClickOrigin({ x: e.clientX, y: e.clientY });
        dispatch(setSelectedNode(data));
      }
    },
    [data, dispatch]
  );

  const handleMouseUp = useCallback(
    (e) => {
      if (e.button === 0) {
        if (hasNodeMoved(clickOrigin, e)) return;
      }
    },
    [clickOrigin]
  );

  // Effects:
  useEffect(() => {
    wrapperRef.current.addEventListener('mousedown', handleMouseDown);
    wrapperRef.current.addEventListener('mouseup', handleMouseUp);
  }, [handleMouseDown, handleMouseUp, clickOrigin, studio.selectedNode]);

  // Return:
  return (
    <TicketNodeWrapper
      ref={wrapperRef}
      style={{
        backgroundColor: studio.selectedNode?.id === id ? '#235789' : '#FEFFFE',
        borderColor: '#235789'
      }}
    >
      <StyledHandle
        type="target"
        position={Position.Top}
        style={{ backgroundColor: 'blue', top: '-15px' }}
      />
      <StyledHandle
        id="api-node-output-true"
        type="source"
        position={Position.Bottom}
        style={{
          backgroundColor: 'green',
          bottom: '-15px',
          left: '25%'
        }}
      />
      <StyledHandle
        id="api-node-output-false"
        type="source"
        position={Position.Bottom}
        style={{
          backgroundColor: '#ED1C24',
          bottom: '-15px',
          left: '75%'
        }}
      />
      <TicketNodeLabel
        htmlFor="text"
        style={{
          color: studio.selectedNode?.id === id ? '#FEFFFE' : '#333533'
        }}
      >
        {label}
      </TicketNodeLabel>
      <Body
        style={{
          color: studio.selectedNode?.id === id ? '#FEFFFE' : '#333533'
        }}
      >
        <Description>
          <Field isActive={studio.selectedNode?.id === id}>
            {!ticketChannel ? (
              <span style={{ fontStyle: 'italic', fontWeight: 400 }}>
                Ticket Channel
              </span>
            ) : (
              ticketChannel
            )}
          </Field>
        </Description>
        <Description>
          <Field isActive={studio.selectedNode?.id === id}>
            {!subject ? (
              <span style={{ fontStyle: 'italic', fontWeight: 400 }}>
                Write a subject...
              </span>
            ) : (
              subject
            )}
          </Field>
        </Description>
      </Body>
    </TicketNodeWrapper>
  );
};

// Exports:
export default TicketNode;
